"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.builder = void 0;
const createWithPath = (rule) => {
    const withPath = (path) => {
        rule.path = path;
        return {
            withPath: createWithPath(rule),
            withErrorMessage: createWithErrorMessage(rule),
            build: createBuild(rule),
        };
    };
    return withPath;
};
const createWithErrorMessage = (rule) => {
    const withErrorMessage = (errorMessage) => {
        rule.errorMessage = errorMessage;
        return {
            withPath: createWithPath(rule),
            withErrorMessage: createWithErrorMessage(rule),
            build: createBuild(rule),
        };
    };
    return withErrorMessage;
};
const createBuild = (rule) => () => rule;
exports.builder = {
    required: () => {
        const rule = { type: 'REQUIRED' };
        return {
            withPath: createWithPath(rule),
            withErrorMessage: createWithErrorMessage(rule),
            build: createBuild(rule),
        };
    },
};
//# sourceMappingURL=RequiredValueBuilder.js.map